// extracted by mini-css-extract-plugin
export default {"errorResetFilters":"TableErrorComponent_errorResetFilters__BFYAA"};